import { LegalEntityClassificationApiModel } from "./LegalEntityClassificationTab.types";
import { ILegalEntityClassificationTab } from "./LegalEntityClassificationTab";
import { useState } from "react";
import { GetLegalEntityClassificationPlanLimit } from "../../auth/planProvider/PlanProvider.hooks.ts";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export default function useLegalEntityClassificationTabHooks(props: ILegalEntityClassificationTab) {
    const [showClassificationDialog, setShowClassificationDialog] = useState(false);

    const url = `/LegalEntityClassification/${props.legalEntityId}`;
    let { isLoading, data, refetch } = useDotLegalQuery<LegalEntityClassificationApiModel>(url);
    const { classificationPlanLimitIsLoading, classificationPlanLimitData, refetchClassificationPlanLimit } = GetLegalEntityClassificationPlanLimit();

    function refetchData() {
        refetch();
        refetchClassificationPlanLimit();
        props.onClassificationsChanged();
    }

    function onClassificationCreated() {
        refetchData();
        setShowClassificationDialog(false);
    }

    return {
        isLoading,
        data,
        onClassificationCreated,
        showClassificationDialog,
        setShowClassificationDialog,
        refetchData,
        classificationPlanLimitIsLoading,
        classificationPlanLimitData,
    };
}
